import {
  AGENT_SUMMARISE,
  COPILOT,
  COPILOT_MODAL,
  REVYRE_AGENT,
} from 'src/modules/constants';
import { ModulesList } from 'src/modules/types';
import CopilotV2 from '.';
import Summarise from './summarise';
import SummariseThunk from './summarise/thunk';
import CopilotV2Thunk from './thunk';
import WorkflowThunk from './workflow/thunk';
import styles from './index.module.scss';

const module: ModulesList = {
  [COPILOT]: {
    path: '/copilot',
    component: CopilotV2,
    thunk: CopilotV2Thunk,
  },
  [COPILOT_MODAL]: {
    component: CopilotV2,
    thunk: CopilotV2Thunk,
    props: {
      classNames: styles.copilotModal,
    },
  },
  [REVYRE_AGENT]: {
    component: CopilotV2,
    thunk: WorkflowThunk,
    props: {
      classNames: styles.copilotModal,
      version: 'workflow',
    },
  },
  [AGENT_SUMMARISE]: {
    component: Summarise,
    thunk: SummariseThunk,
  },
};

export default module;
